export default "__VITE_ASSET__BTBzhJvA__"